import { format } from 'date-fns';
import { shortText, ucWords } from '../../../Utilities/Utilities';
import { Link } from 'react-router-dom';
import { DEFAULT_DATE_FORMATE, DEFAULT_LOCAL_PATH } from '../../../constents';
import { MdWatchLater, MdCheckCircle, MdCancel } from 'react-icons/md';
import parse from 'html-react-parser';

const FAX_SUCCESS_STATUSES = [
  'sent',
  'success',
  'completed',
  'sucessfuly transmitted',
  'successfully transmitted',
];
const FAX_FAILED_STATUSES = [
  'failed',
  'retry exceeded',
  'no dial tone',
  'busy',
  'fatal error',
  'line unavailable',
  'canceled',
  'cancelled',
  'canceling',
];

function getFaxDeliveryMeta(deliveryStatus) {
  const raw = (deliveryStatus || '').trim();
  const status = raw.toLowerCase();

  if (
    FAX_SUCCESS_STATUSES.includes(status) ||
    status.includes('no longer in queue')
  ) {
    return {
      Icon: MdCheckCircle,
      className: 'referral-fax-status-icon is-success',
      title: 'Fax sent successfully',
    };
  }

  if (FAX_FAILED_STATUSES.includes(status)) {
    return {
      Icon: MdCancel,
      className: 'referral-fax-status-icon is-failed',
      title: raw || 'Fax failed',
    };
  }

  return {
    Icon: MdWatchLater,
    className: 'referral-fax-status-icon is-pending',
    title: raw || 'Fax pending',
  };
}

function ReferralList({ item, handleChangeStatus }) {
  const urgencyLabel =
    item?.urgencyLevel ||
    (typeof item?.urgency_level === 'string' ? item.urgency_level : '') ||
    '';

  const referralDate = item?.referralDate || item?.added_date || '';
  const hasFax =
    !!item?.doc_fax_id && item.doc_fax_id !== 0 && item.doc_fax_id !== '0';
  const rawFaxDate = item?.faxSentDate || item?.deliveryDate || '';
  const faxSentDate = rawFaxDate
    ? format(new Date(rawFaxDate), DEFAULT_DATE_FORMATE)
    : '';
  const faxMeta = hasFax ? getFaxDeliveryMeta(item?.delivery_status) : null;
  const FaxStatusIcon = faxMeta?.Icon;

  return (
    <>
      <div className="border-r border-r-lightgray p-1-5">
        <select
          name="action"
          id="action"
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (handleChangeStatus) {
              handleChangeStatus(item.id, e.target.value);
            }
          }}
          value={item?.referral_status?.toString()}
        >
          <option value="1">Pending</option>
          <option value="2">Scheduled</option>
          <option value="3">Completed</option>
          <option value="4">Canceled</option>
          <option value="5">Removed</option>
        </select>
      </div>

      <div className="border-r border-r-lightgray p-1-5">
        <Link
          to={`${DEFAULT_LOCAL_PATH}/patient/counNote/${item.patient_id}`}
          onClick={(e) => e.stopPropagation()}
        >
          {ucWords(item.patientName)}
        </Link>
        <br />
        Chart # {item.chart_number}
        <br />
        DOB {item?.dob}
      </div>

      <div className="border-r border-r-lightgray p-1-5">
        {parse(shortText(item?.referal_name, 20) || '')}
      </div>

      <div className="border-r border-r-lightgray p-1-5">{referralDate}</div>

      <div className="border-r border-r-lightgray p-1-5 fw-600">
        {parse(shortText(item?.reciverNane, 20) || '')}
      </div>

      <div className="border-r border-r-lightgray p-1-5">
        {urgencyLabel ? ucWords(urgencyLabel) : ''}
      </div>

      <div className="border-r border-r-lightgray p-1-5" title={item?.reason}>
        {parse(item?.reasonForReferral || '')}
      </div>

      <div className="border-r border-r-lightgray p-1-5">
        Appt. Scheduled:{' '}
        <span className={item?.appTaken === 'No' ? 'referral-text-no' : ''}>
          {item?.appTaken}
        </span>
        <br />
        Patient Informed:{' '}
        <span className={item?.patInformed === 'No' ? 'referral-text-no' : ''}>
          {item?.patInformed}
        </span>
      </div>

      <div className="border-r border-r-lightgray p-1-5">
        {item?.appointmentTakenDate || item?.planDate || ''}
      </div>

      <div
        className="border-r border-r-lightgray p-1-5 referral-sent-via"
        onClick={(e) => e.stopPropagation()}
      >
        {(item?.emailSentDate || item?.rptSentViaSecureDate) && (
          <div className="ref-act-pills">
            Emailed {item?.emailSentDate || item?.rptSentViaSecureDate}
          </div>
        )}
        {item?.printedDate && (
          <div className="ref-act-pills">Printed {item.printedDate}</div>
        )}
        {hasFax && (
          <div className="referral-fax-status-row">
            <div className="ref-act-pills">
              Faxed
              {faxSentDate ? (
                <>
                  <br />
                  {faxSentDate}
                </>
              ) : null}
            </div>
            {FaxStatusIcon && (
              <FaxStatusIcon
                className={faxMeta.className}
                title={faxMeta.title}
                aria-label={faxMeta.title}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default ReferralList;
